import React from 'react';
import { translate } from 'translations/i18n';
import ReactSelectCreatable from 'react-select/creatable';
import styled from 'styled-components';

import { REACT_SELECT_STYLES } from 'helpers/styles';

const TagContainer = styled.div`
  max-width: 532px;
`;

const formatOptions = (options: string[]): MultiselectOption[] => {
  return options.map((option) => ({
    label: option,
    value: option,
  }));
};

export type TagSelectProps = {
  existingTags: string[];
  setFieldValue: (field: string, value: string[]) => void;
  setFieldTouched: (field: string) => void;
  tagType: string;
  options: string[];
  isLoading: boolean;
  noOptionsAvailableMessage: string;
  error: string | null;
};

type MultiselectOption = {
  label: string;
  value: string;
};

export default function TagSelect({
  existingTags,
  setFieldValue,
  setFieldTouched,
  tagType,
  options,
  isLoading,
  noOptionsAvailableMessage,
  error,
}: TagSelectProps) {
  const handleOnChange = (selection: MultiselectOption[] = []) => {
    const tags = selection.map((tag) => tag.label);
    setFieldValue(tagType, tags);
  };

  const handleFormatCreateLabel = (inputValue: string) => {
    return translate('showcases.create.publishWizard.tags.createMessage', {
      inputValue,
    });
  };

  return (
    <TagContainer>
      <ReactSelectCreatable
        aria-label={translate('showcases.create.publishWizard.tags.select', {
          tagType,
        })}
        formatCreateLabel={handleFormatCreateLabel}
        isMulti
        isLoading={isLoading}
        onBlur={() => setFieldTouched(tagType)}
        name={tagType}
        getOptionLabel={({ label }) => label}
        getOptionValue={({ value }) => value}
        placeholder=""
        noOptionsMessage={() => error || noOptionsAvailableMessage}
        onChange={handleOnChange}
        options={formatOptions(options)}
        styles={REACT_SELECT_STYLES}
        value={formatOptions(existingTags)}
      />
    </TagContainer>
  );
}
